/**
 * 支付记录
 */
import { PAYLIST } from '../types';

export default {
    name: `${PAYLIST}`,
    path: '/payList',
    component: () => import(/* webpackChunkName: 'payList' */ '@/views/payList/'),
    redirect: { name: `${PAYLIST}Index` },
    meta: {
        title: '支付记录',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${PAYLIST}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'payList' */ '@/views/payList/home/Home.vue'),
        },
    ],
};
